import React, { useCallback, useEffect } from 'react';
import { useFormikContext } from 'formik';
import UserItem from './item/UserItem';
import useStyles from './UserList.styles';

const UserList = () => {
  const classes = useStyles();

  const { values, setFieldValue } = useFormikContext();

  const checkIfLastEntryIsDirty = useCallback(() => {
    const lastUser = values.users[values.users.length - 1];
    return !!(lastUser && (lastUser.name || lastUser.email || lastUser.description));
  }, [values.users]);

  useEffect(() => {
    if (checkIfLastEntryIsDirty()) {
      setFieldValue(`users.${values.users.length}`, {
        id: 0,
        name: '',
        email: '',
        description: '',
      });
    }
  }, [checkIfLastEntryIsDirty, setFieldValue, values.users]);

  const handleDelete = useCallback(
    (index) => {
      const { users } = values;
      const cleanedUsers = [...users];
      cleanedUsers.splice(index, 1);
      setFieldValue('users', cleanedUsers);
    },
    [setFieldValue, values]
  );

  return (
    <div className={classes.root}>
      {values.users.map((user, index) => (
        <UserItem key={String(index)} index={index} onDelete={handleDelete} />
      ))}
    </div>
  );
};

UserList.propTypes = {};

UserList.defaultProps = {};

export default UserList;
